import React, { useState, useEffect, useRef } from "react";
import { Input, Checkbox } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";

function PuntModal({
  state,
  dispatch,
  close,
  update,
  item,
  school_id,
  loadAllPlayerList,
  schoolCustomStats,
  getStats,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  distanceModal,
  handleExpandToggle,
}) {
  const [modalWidth, setModalWidth] = useState(580);
  const [inside, setInside] = useState(item.punt_inside_20);
  const [fair, setFair] = useState(item.punt_fair_catch);
  const [distance, setDistance] = useState(item.punts);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(500);
    } else {
      setModalWidth(580);
    }
  }, []);

  return (
    state.punt && (
      <div className="w-full flex justify-between mt-2 text-[#20364B] text-sm font-semibold">
        <div className="w-[49%] border rounded-md overflow-hidden">
          <div className="flex w-full">
            <div className="w-[25%] p-2 flex items-center justify-center bg-[#F3F5F7] border-r">
              Punt
            </div>
            <div className="w-[20%] p-2 flex items-center justify-center border-r">
              <Input
                size="small"
                className="w-[70%]"
                defaultValue={distance}
                onChange={({ target: { value } }) => setDistance(value)}
                onPressEnter={() =>
                  update(item.id, item.athlete, "punts", distance)
                }
              />
            </div>
            <div className="w-[25%] p-2 flex items-center justify-center border-r">
              <Checkbox
                defaultChecked={item.punt_inside_20}
                onChange={({ target: { checked: e } }) => {
                  const val = e ? 1 : 0;
                  setInside(val);
                  update(item.id, item.athlete, "punt_inside_20", val);
                }}
              />
              <span className="ml-1 font-normal">Inside 20</span>
            </div>
            <div className="w-[30%] p-2 flex items-center justify-center">
              <Checkbox
                defaultChecked={item.punt_fair_catch}
                onChange={({ target: { checked: e } }) => {
                  const val = e ? 1 : 0;
                  setFair(val);
                  update(item.id, item.athlete, "punt_fair_catch", val);
                }}
              />
              <span className="ml-1 font-normal">Fair Catch</span>
            </div>
          </div>
        </div>
        <div className="w-[49%]">
          <button
            onClick={() => handleExpandToggle(item, "punt-modal")}
            className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
          >
            <img src={floppyDiskImg} className="w-6" />
            <span className="ml-2">Save and close</span>
          </button>
        </div>
      </div>
    )
  );
}

export default PuntModal;
